// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","button":"NotFound_button__tmXsI","image":"NotFound_image__q660q"};